import { render, staticRenderFns } from "./Embed.vue?vue&type=template&id=160ea0c2&scoped=true&"
import script from "./Embed.vue?vue&type=script&lang=js&"
export * from "./Embed.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Embed.vue?vue&type=style&index=0&id=160ea0c2&lang=sass&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "160ea0c2",
  "b1fcdbd4"
  
)

export default component.exports